import {combineReducers} from 'redux';

import settings from './engineer-settings';
import engineers from './engineers';
import nonEngineers from './non-engineers';

export default combineReducers({settings, engineers, nonEngineers});


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/dlo.js